var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.15a.85.85 0 0 0-.85.85v24a.85.85 0 0 0 1.7 0v-6.42H26a.85.85 0 0 0 .717-1.307l-5.043-7.908 5.043-7.908A.85.85 0 0 0 26 3.15Zm.85 1.7h17.6l-4.5 7.058a.85.85 0 0 0 0 .914l4.5 7.059H6.85Z"
  })));
};
export default SvgFlag;